import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.714.917a.816.816 0 0 0-1.423 0 22.502 22.502 0 0 0-1.714 3.968.915.915 0 0 1-.853.62c-1.192.03-2.38.15-3.556.354-.645.113-.887.848-.429 1.296a26.667 26.667 0 0 0 2.842 2.41.854.854 0 0 1 .315.96 22.498 22.498 0 0 0-.95 4.106c-.084.63.59 1.073 1.175.773a23.825 23.825 0 0 0 3.316-2.06.959.959 0 0 1 1.13 0 23.738 23.738 0 0 0 3.317 2.06c.584.3 1.258-.144 1.175-.773a22.498 22.498 0 0 0-.95-4.106.853.853 0 0 1 .315-.96 26.246 26.246 0 0 0 2.842-2.41c.458-.448.216-1.183-.43-1.296a24.166 24.166 0 0 0-3.555-.355.917.917 0 0 1-.853-.619A22.505 22.505 0 0 0 8.714.917Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }